export const SET_PROPERTIES = 'SET_PROPERTIES';
export const SET_PROPERTY_TO_EDIT = 'SET_PROPERTY_TO_EDIT';
export const SET_LATLNG = 'SET_LATLNG';
export const UPDATE_PROPERTY = 'UPDATE_PROPERTY';